import styled from 'styled-components';

export const ModelBody = styled.section`
  display: flex;
  flex-direction: column;
  border-left: 8px solid ${({ theme }) => theme.colors.primary.main};

  @media ${({ theme }) => theme.devices.mobile} {
    border-left: 4px solid ${({ theme }) => theme.colors.primary.main};
  }
`;
